import React,{useEffect,useState} from 'react';
import './comp_marksheet_pro_one.css';
import logoImg from '../assets/images/logo.png';
import ResPicDef from '../assets/images/schoo_pic.png';
import {bindEdit} from '../function_lib/common_lib';
import { setRegion } from 'react-geocode';


function exportPdf(pageType) {
    var whe = window.innerHeight;
    var wwid = window.innerWidth;

    let data = document.getElementById("divPrintMarkSheetContent").innerHTML;
    /*
    alert(data);
    var doc = new DOMParser().parseFromString(data, "text/xml");

    alert(doc.getElementsByTagName("<div>")[1]);
    */
    var printWindow = window.open('', '', 'width=' + (wwid - 20) + ',height=' + (whe - 10) + '');
    printWindow.document.write('<html><head><title>Export Data</title>');
    //printWindow.document.write('<link rel="stylesheet" href="~/plugins/fontawesome-free/css/all.min.css">');
    printWindow.document.write('<link rel="stylesheet" href="https://code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css">');
    printWindow.document.write('<link rel="stylesheet" href="https://cdn.datatables.net/1.12.1/css/jquery.dataTables.min.css">');
    printWindow.document.write('<link rel="stylesheet" href="comp_marksheet_pro_one.css?20042025.092">');
    printWindow.document.write('<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,400i,700">');
    if(pageType==="1"){
        printWindow.document.write('<style>@page { size: landscape; }table, th, td {border: 0.5px solid;}table{width:100%;border-spacing:0;}</style>');
    }else{
        printWindow.document.write('<style>table, th, td {border: 0.5px solid;}table{width:100%;border-spacing:0;}</style>');
    }
    
    
    printWindow.document.write('</head><body >');
    printWindow.document.write(data);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    //alert(printWindow.document.getElementById("exp_body").innerHTML);
    //printWindow.document.getElementById("exp_body").removeAttribute("style");
    //delete cell from table
    // let tbList = printWindow.document.getElementById("ptrTable");
    // let tbRow = tbList.rows;
    // //alert(tbRow.length);
    // for (let i = 0; i < tbRow[0].cells.length; i++) {
    //     var str = tbRow[0].cells[i].innerHTML;
    //     //alert(str);
    //     if (str.search("Action") != -1) {
    //         for (var j = 0; j < tbRow.length; j++) {

    //             // Deleting the ith cell of each row
    //             tbRow[j].deleteCell(i);
    //         }
    //     }
    // }

    setTimeout(function () {
        printWindow.print();
    }, 500);
    return false;
}

const Comp_Marksheet_Pro_One=(props)=>{
    const [examSubjects,setExamSubjects]=useState([]);
    const [examRoll,setExamRoll]=useState("");
    const [attend,setAttend]=useState("")
    const [mainResult,setMainResult]=useState("");

    useEffect(()=>{
        if(props.lsStudentBasic.length>0){
           // bindEdit();
           //alert(JSON.stringify(props.studentPrintMarks));
           let tmpMarks={}
           for(let i=0;i<props.studentPrintMarks.length;i++){
            //alert(props.studentPrintMarks[i]["subject_marks"]);
            setExamSubjects(JSON.parse(props.studentPrintMarks[i]["subject_marks"]));
            break;
           }
         
           let totalDays=0;
           let totalPresent=0;
           for(let i=0;i<props.studentPrintMarks.length;i++){
            setExamRoll(props.studentPrintMarks[i]["roll_number"])
            totalDays+=parseInt(props.studentPrintMarks[i]["attend_total"]);
            totalPresent+=parseInt(props.studentPrintMarks[i]["attend_present"]);
            
            if(props.studentPrintMarks[i]["exam_nm"]==="Final Exam"){
                setMainResult(props.studentPrintMarks[i]["result_pass"]);
            }
            
           }
           setAttend(totalPresent+"/"+totalDays);
        }
        //alert(JSON.stringify(props.lsStudentBasic));
         //alert(JSON.stringify(props.editItem));
    },[props.studentPrintMarks])
    return(
        <div className="modal fade bd-example-modal-xl"  id="divPrintMarkSheet" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div className="modal-dialog modal-xl" role="document">
      <div className="modal-content">
      <div className="modal-header bg-primary">
          <h5 className="modal-title text-white" id="exampleModalLabel">Export Report</h5>
          <a href={"javascript:void(0)"} onClick={()=>exportPdf(props.pageType)} className="btn btn-sm btn-danger float-right">Export/Print</a>

          <button type="button" className="close text-white" data-bs-dismiss="modal" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true" className="text-white">&times;</span>
          </button>
        </div>
     
        <div id="divPrintMarkSheetContent" className="modal-body">
        {props.lsStudentBasic.length>0?
        <div class="report-card akshatinternational">
        <div class="header">
            <img src={logoImg} alt="School Logo" class="logo"/>
            <img src={ResPicDef} alt="School Emblem" class="logo-right"/>
            <div class="school-name">CITY MONTESSORI HIGH SCHOOL</div>
            <div class="school-address">MP Board, Affiliation No. 21128264, Dise Code: 23210702717</div>
            <div class="school-info">Indira Nagar, Ujjain (M.P.)</div>
            <div class="school-info">Email: citymontessori786@gmail.com</div>
            <div class="school-info">Website: www.citymontessorihighschool.in</div>
        </div>

        <div class="report-title">ANNUAL REPORT CARD</div>
        <div class="academic-session">Academic Session: {props.editItem["session_name"]}</div>
        {/* <div class="academic-session">CLASS: {props.editItem["class_name"]+" Sec."+props.editItem["section"]}</div> */}

        <table class="student-info">
            <tr>
                <th colspan="3"><center>CLASS: {props.editItem["class_name"]+" Sec."+props.editItem["section"]}</center></th>
                
                
            </tr>
            <tr>
                <td>Name:<b>  {props.editItem["student_name"]}</b></td>
                <td>Roll No.<b>  {examRoll}</b></td>
                
                <td>Scholar No.:<b>  {props.editItem["scholar_no"]}</b></td>
               
            </tr>
            <tr>
            <td>Father's Name:<b>  {props.editItem["father_name"]}</b></td>
            <td>Date of Birth:<b>  {props.editItem["fmt_dob"]}</b></td>
            <td>SSMID No.:<b>  {props.editItem["stu_ssmid"]}</b></td>
                
              
               
               
            </tr>
            <tr>
            <td>Mother's Name:<b>  {props.editItem["mother_name"]}</b></td>
            
            <td>Mobile No.:<b>  {props.editItem["whats_no"]}</b></td>
                <td>Aadhar No.:<b>  {props.editItem["stu_aadhaar_no"]}</b></td>
                
            </tr>
           
        </table>

        <div class="academic-section">
            <div class="academic-header">Academic Part</div>
            <table class="academic-table">
                <tr>
                    <th rowspan="2">Subjects</th>
                    {props.studentPrintMarks.map((item,index)=>{
                        return <th>{item["exam_nm"]}</th>
                    })}
                  
                </tr>
                <tr>
                    {props.studentPrintMarks.map((item,index)=>{
                        return <th>{item["outs_marks"]+" Marks"}</th>
                    })}
                </tr>
              
             {examSubjects.map((item,index)=>{
                if(item["academic_part"]==="Academic"){

                    let mapArr=[];
                    {props.studentPrintMarks.map((itemMarks,indexMarks)=>{
                        let subjectsMarks=JSON.parse(itemMarks["subject_marks"])
                        for(let s=0;s<subjectsMarks.length;s++){
                            if(subjectsMarks[s]["subject_name"]===item["subject_name"]){
                                mapArr.push({outs_marks:itemMarks["outs_marks"],marks_obt:subjectsMarks[s]["obtain_marks"],total_marks:subjectsMarks[s]["total_marks"]})
                            }
                        }
                    })}
                   
                    return <tr>
                        <td>{item["subject_name"]}</td>
                        {mapArr.map((displayObt,dispIndex)=>{
                            let displayMarks=displayObt["marks_obt"];
                            if(displayObt["total_marks"]==="0"){
                                displayMarks="";
                            }else if(displayMarks==="-1"){
                                displayMarks="Absent";
                            }
                            //alert(displayObt["total_marks"]);
                            if(displayObt["total_marks"]!=="0" && (String(displayObt["outs_marks"])!==String(displayObt["total_marks"]))){
                                displayMarks=displayMarks+" / "+displayObt["total_marks"];
                            }
                            // if(displayObt["total_marks"]==="10" || displayObt["total_marks"]===10){
                            //     displayMarks=displayMarks+"/"+"10";
                            // }

                            return <td>{displayMarks}</td>
                        })}
                    </tr>

                }
               
             })}
            <tr>
                <td><b>Total</b></td>
                {props.studentPrintMarks.map((ptrTotal,ptrIndex)=>{
                    return <td><b>{ptrTotal["obtain_marks"]+" / "+ptrTotal["total_marks"]}</b></td>
                })}
            </tr>
              
              
            </table>
        </div>

        {/* <table class="grand-total">
            <tr>
                <td>Grand total</td>
                <td>468/500</td>
                <td>Percentage</td>
                <td>93.6%</td>
                <td>Total Grade</td>
                <td>A1</td>
            </tr>
        </table> */}
   
          <div className='academic-section'>
            <table class="academic-table">
            <thead> <tr><th colSpan={"5"}>
                <center> Co-Scholastic Activities
              
              (3 Point Grading Scale A,B,C)</center>
               
                    </th></tr></thead>
               
                <tr>

                    <th></th>
                    {examSubjects.map((item,index)=>{
                        if(item["academic_part"]==="Co-Scholastic"){
                            return <th>{item["subject_name"]}</th>
                        }
                        
                    })}
                   
                   
                </tr>

{/* scholastic subjects */}
{props.studentPrintMarks.map((itemResult,indexResult)=>{
   // alert(itemResult["exam_nm"]);
    if(itemResult["exam_nm"]==="Terminal Exam" || itemResult["exam_nm"]==="Half Yearly Exam" ||
    itemResult["exam_nm"]==="Final Exam"){
        let subjectsMarks=JSON.parse(itemResult["subject_marks"])
        //alert(JSON.stringify(subjectsMarks));
        return <tr>
            <td>{itemResult["exam_nm"]}</td>
            {subjectsMarks.map((itemSub,subIndex)=>{
                if(itemSub["academic_part"]==="Co-Scholastic"){
                    return <td>{itemSub["grade_applied"]!=="NA"?itemSub["grade_applied"]:''}</td>
                }
                
            })}
        </tr>
    }
})}

              
            </table>
  </div>


        <table class="attendance-table">
            <tr>
                <td>Attendance: <b>{attend}</b></td>
                <td>Final Result: <b>{mainResult}</b></td>
                <td>Remark: School will reopen on 5th April, 2025</td>
                
            </tr>
        </table>

<div class="academic-section">
        <table class="academic-table">
            <thead>
                <tr>
                <th><center>Exams</center></th>
                <th><center>Obt./Total</center></th>
                <th><center>Percentage</center></th>
                <th><center>Division</center></th>
                <th><center>Grade</center></th>
                <th><center>Rank</center></th>
                <th><center>Remark</center></th>
                </tr>
            </thead>
            <tbody>
                {props.studentPrintMarks.map((lastLine,lastIndex)=>{
                     if(lastLine["exam_nm"]==="Terminal Exam" || lastLine["exam_nm"]==="Half Yearly Exam"
                     || lastLine["exam_nm"]==="Final Exam"
                     ){
                        //alert(JSON.stringify(lastLine))
return  <tr>
<td>{lastLine["exam_nm"]}</td>
<td>{lastLine["obtain_marks"]}/{lastLine["total_marks"]}</td>
<td>{(lastLine["display_at"]!=="not" && lastLine["marks_per"]!="0")?lastLine["marks_per"]+"%":'-'}</td>
<td>{lastLine["display_at"]!=="not"?lastLine["obt_division"]+" Division":'-'}</td>
<td>{lastLine["display_at"]!=="not"?lastLine["obt_grade"]:'-'}</td>
<td>{lastLine["display_at"]!=="not"?<>{lastLine["rank"]!=="0"?lastLine["rank"]+" Rank":'-'}</>:'-'} </td>
<td>{lastLine["display_at"]!=="not"?lastLine["remarks"]:'-'}</td>
</tr>
                     }

                })}
              
            </tbody>
        </table>    
            
    
        </div>

        <div class="signature-section">
            <div class="signature">
                <div class="signature-line"></div>
                <div style={{"padding-bottom":"2px","font-size":"12px"}}><b>PARENT'S SIGNATURE</b></div>
            </div>
            <div class="signature">
                <div class="signature-line"></div>
                <div style={{"padding-bottom":"2px","font-size":"12px"}}><b>CLASS TEACHER'S SIGNATURE</b></div>
            </div>
            <div class="signature">
                <div class="signature-line"></div>
                <div style={{"padding-bottom":"2px","font-size":"12px"}}><b>PRINCIPAL'S SEAL AND SIGNATURE</b></div>
            </div>
        </div>
       
        <div class="grade-scale-section">
            <table class="grade-scale">
                {/* <tr>
                    <th colspan="9">Scholastic Subject</th>
                    <th colspan="6">Co-Scholastic Topics</th>
                </tr> */}
                <tr>
                    <th>Marks Range</th>
                    <th>91-100</th>
                    <th>81-90</th>
                    <th>71-80</th>
                    <th>61-70</th>
                    <th>51-60</th>
                    <th>41-50</th>
                    <th>33-40</th>
                    <th>0-32/Fail</th>
                    <th>Grace</th>
                    <th>Grade Range</th>
                    <th>5</th>
                    <th>4</th>
                    <th>3</th>
                    
                </tr>
                <tr>
                    <th>Grade</th>
                    <td>A1</td>
                    <td>A2</td>
                    <td>B1</td>
                    <td>B2</td>
                    <td>C1</td>
                    <td>C2</td>
                    <td>D</td>
                    <td>F</td>
                    <td>G</td>
                    <th>Grade</th>
                    <td>A</td>
                    <td>B</td>
                    <td>C</td>
                   
                </tr>
            </table>
        </div>

    </div>:'No Details Found'}

    </div>

    </div>
      </div>
      </div>
    );
}

export default Comp_Marksheet_Pro_One;